<template>
  <button :class="['rounded-square-button', active ? 'active' : '']" 
    :disabled="disabled" 
    @click="onClick"
    @keydown="handleKeyDown" 
    :aria-labelledby="ariaLabel"
    :aria-describedby="ariaDescription"
  >
    <img v-if="image" :src="image" :alt="imageAlt" :class="[tall ? 'tall' : '', xtall ? 'x-tall' : '']" />
    <span v-else class="text">{{ text }}</span>
  </button>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
    ariaLabel: String,
    ariaDescription: String,
    active: Boolean,
    onClick: Function,
    enterPress: Function,
    image: String,
    imageAlt: String,
    text: String,
    tall: Boolean,
    xtall: Boolean,
  },
  methods: {
    handleKeyDown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.target.blur();
        this.enterPress?.(event);
      }
    },
  },
};
</script>

<style lang="scss">
.rounded-square-button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: map-get($component-sizes, button-height);
  width: map-get($component-sizes, button-height);
  border-radius: 0.8rem;
  font-size: 1rem;
  border: none;
  transition: background-color 0.5s ease;
  font-weight: bold;
  outline: none;

  &[disabled] {
    background-color: map-get($component-colours, button-colour-disabled);
    color: map-get($component-colours, button-font-colour-disabled);
  }

  &.active {
    background-color: map-get($colours, accent-purple-3);
  }

  &:focus-visible {
    box-shadow: 0 0 0 0.3rem rgba(255, 233, 254, 0.4);
    outline: solid 0.2rem rgba(255, 233, 254, 1);
    border: solid 0.1rem map-get($colours, accent-purple3);
  }


  img {
    max-height: 2.4rem;

    &.tall {
      max-height: 2.8rem;
    }

    &.x-tall {
      max-height: 3.2rem;
    }
  }

  .text {
    margin-top: 0.2rem;
  }
}
</style>
